import { NOTIFICATION_TYPE_OPTIONS } from '@vlabs/api-bindings/src/constants';

export const defaultNotification = {
  filters: {
    name: '',
    type: NOTIFICATION_TYPE_OPTIONS.raw[1],
  },
  ui: { enable: false },
  telegram: {
    enable: false,
    targets: '',
    recipients: '' },
  email: {
    enable: false,
    targets: '',
    recipients: '' },
};

export const defaultVideoAnalytics = {
  filters: {
    type: NOTIFICATION_TYPE_OPTIONS.raw[0],
    name: '',
    videoanalytics: [],
    fire_type: [],
  },
  ui: {
    enable: false,
    recipients: {
      sound: false,
      popup: false,
    },
  },
  telegram: { enable: null },
};
